/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: Rex
 */

import {
  fix,
  arrayRemoveEmptyElement,
  arrayFind,
  aoformQuestionShouldDisplay,
  checkSubQuestionCondition
} from './AOFormUtils';
import { isArrayFn } from './ValidationUtils';
import { deepClone } from './index'

export const handleJsonToAnswer = (json, countryListDatas) => {
  let flattenObj = {};
  let panelStatusObj = {};
  const sections = deepClone(json).sections;
  sections && sections.forEach(section => {
    section.sectionId === "S003" && findAnswerBySection(json, section, countryListDatas, flattenObj, panelStatusObj)
  });
  return [flattenObj, panelStatusObj]
};

const findAnswerBySection = (app, section, countryListDatas, flattenObj, panelStatusObj) => {
  const {
    questions
  } = section;
  handleSubQuestion(app, questions, countryListDatas, flattenObj, panelStatusObj);
  if (!!panelStatusObj) {
    for (let key in panelStatusObj) {
      panelStatusObj[key] = panelStatusObj[key].join()
    }
  }
};

const handleSubQuestion = (
  app,
  subQuestions,
  countryListDatas,
  flattenObj,
  panelStatusObj,
  layerIndex = 0,
  subQuestionMatch = true
) => {

  if (!subQuestions) {
    return null;
  }

  return subQuestions.map((obj) => {
    const shouldDisplay = aoformQuestionShouldDisplay(app, obj);
    if (!shouldDisplay) {
      // handle hidden question's answer, only for outer answers
      if (layerIndex === 1 && obj.questionIndicator) {
        let indicator = obj.questionIndicator;
        if ((obj.answerType === 14 || obj.answerType === 17 || obj.answerType === 18 || obj.answerType === 22)
            && obj.questionIndicator.indexOf("Group", [obj.questionIndicator.length - 5]) !== -1) {
          // handle repeat group's indicator, clear group answer
          const endIndex = obj.questionIndicator.indexOf("Group", [obj.questionIndicator.length - 5]);
          indicator = obj.questionIndicator.slice(0, endIndex);
          flattenObj[indicator] = null;
          if (obj.answerType === 14) {
            // clear connected entities' question status
            panelStatusObj[indicator] = [0]
          }
        } else if (obj.answerType === 7 || obj.answerType === 8) {
          // handle phone number and its separated value
          obj.subQuestions.forEach(question => {
            const {
              questionIndicator,
              userAnswer } = question;
            if (userAnswer) {
              flattenObj[questionIndicator] = "";
            }
          });
          flattenObj[indicator] = ""
        } else if (obj.questionIndicator === "TypeOfSpeEcoZone") {
          if (flattenObj["PilotFreeTradZone"] && flattenObj["PilotFreeTradZone"] === "Yes") {
            flattenObj["TypeOfSpeEcoZone"] = "PilFreeTradeZone_SpeSup"
          } else {
            flattenObj[indicator] = ""
          }
        } else {
          flattenObj[indicator] = ""
        }
      }
      return null
    }
    const {
      questionId,
      questionIndicator,
      questionStatus,
      canRepeat,
      answerType,
      userAnswer,
      answers } = obj;

    let extractedAnswer = null;

    switch (answerType) {
      case 1: // Radio button
      case 5: // DropDownList
      {
        if (userAnswer) {
          const subQuestionMatch = checkSubQuestionCondition(app, obj);
          const singleAnswer = arrayFind(answers, userAnswer.chosenAnswerId, "answerId");
          extractedAnswer = {};
          if (singleAnswer && singleAnswer.answerIndicator) {
            extractedAnswer[questionIndicator] = singleAnswer.answerIndicator;
            if (obj.subQuestions) {
              if (layerIndex === 1) {
                handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, layerIndex, subQuestionMatch)
              } else {
                // handle combo answers, 'value' for current question's answer, each key for subQuestion's answer
                let objWithSubQuestion = {};
                objWithSubQuestion["value"] = singleAnswer.answerIndicator;
                const subIndex = layerIndex + 1;
                const spSubQuestions = arrayRemoveEmptyElement(
                  handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, subIndex, subQuestionMatch)
                );
                for (let key in spSubQuestions) {
                  const subQuestionObj = spSubQuestions[key];
                  for (let subQuestionKey in subQuestionObj) {
                    // if subQuestionCondition is match for display, set value to subQuestion, or clear it
                    objWithSubQuestion[subQuestionKey] = subQuestionMatch ? subQuestionObj[subQuestionKey] : ""
                  }
                }
                extractedAnswer[questionIndicator] = objWithSubQuestion
              }
            }
          } else {
            extractedAnswer[questionIndicator] = ""
          }
        } else {
          extractedAnswer = {};
          extractedAnswer[questionIndicator] = null
        }
        break;
      }
      case 27: // CountryList
        if (userAnswer) {
          const baseAnswerId = questionId.replace('Q', 'A') + ":";
          let singleAnswer = null;
          const length = !!countryListDatas ? countryListDatas.length : 0;
          for (let i = 0; i < length; i++) {
            const country = countryListDatas[i];
            const targetId = baseAnswerId + fix(i + 1);
            if (targetId === userAnswer.chosenAnswerId) {
              singleAnswer = country;
              break;
            }
          }
          if (singleAnswer && singleAnswer.indicator) {
            extractedAnswer = {};
            extractedAnswer[questionIndicator] = singleAnswer.indicator
          } else {
            extractedAnswer = {};
            extractedAnswer[questionIndicator] = ""
          }
        } else {
          extractedAnswer = {};
          extractedAnswer[questionIndicator] = null
        }
        break;
      case 2: // Check box
      {
        if (userAnswer) {
          let tempValue = null;
          const chosenAnswers = userAnswer.chosenAnswerId && userAnswer.chosenAnswerId.split(',');
          chosenAnswers && chosenAnswers.forEach(eachAnswer => {
            const multipleAnswer = arrayFind(answers, eachAnswer, "answerId");
            if (multipleAnswer) {
              tempValue = tempValue
                ? tempValue + "," + multipleAnswer.answerIndicator
                : multipleAnswer.answerIndicator
            }
          });
          if (tempValue && tempValue.length > 0) {
            extractedAnswer = {};
            extractedAnswer[questionIndicator] = tempValue;
            if (obj.subQuestions) {
              if (layerIndex === 1) {
                // handle outer answers
                handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, layerIndex)
              } else {
                // handle combo answers, 'value' for current question's answer, each key for subQuestion's answer
                let objWithSubQuestion = {};
                objWithSubQuestion["value"] = tempValue;
                const subIndex = layerIndex + 1;
                const spSubQuestions = arrayRemoveEmptyElement(
                  handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, subIndex)
                );
                for (let key in spSubQuestions) {
                  const subQuestionObj = spSubQuestions[key];
                  for (let subQuestionKey in subQuestionObj) {
                    objWithSubQuestion[subQuestionKey] = subQuestionObj[subQuestionKey]
                  }
                }
                extractedAnswer[questionIndicator] = objWithSubQuestion
              }
            }
          } else {
            // clear value for non-selected check box
            extractedAnswer = {};
            extractedAnswer[questionIndicator] = ""
          }
        }
        break;
      }
      case 4: // Input
      case 21: // InputDigit
      case 24: // TextArea
      case 23: // InputPercentage
      case 7: // Mobile number
      case 8: // Telephone number
      case 16: // DateInput
      {
        extractedAnswer = {};
        if (userAnswer && answerType !== 16) {
          extractedAnswer[questionIndicator] = subQuestionMatch ? userAnswer.contents.toString() : "";
        } else if (userAnswer && answerType === 16) {
          if (subQuestionMatch) {
            extractedAnswer = {};
            if (obj.subQuestions) {
              const subQuestionMatch = checkSubQuestionCondition(app, obj);
              if (layerIndex === 1) {
                handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, layerIndex, subQuestionMatch)
              } else {
                // handle combo answers, 'value' for current question's answer, each key for subQuestion's answer
                let objWithSubQuestion = {};
                objWithSubQuestion["value"] = userAnswer.contents.toString();
                const subIndex = layerIndex + 1;
                const spSubQuestions = subQuestionMatch && arrayRemoveEmptyElement(
                    handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, subIndex)
                );
                for (let key in spSubQuestions) {
                  const subQuestionObj = spSubQuestions[key];
                  for (let subQuestionKey in subQuestionObj) {
                    objWithSubQuestion[subQuestionKey] = subQuestionObj[subQuestionKey]
                  }
                }
                extractedAnswer[questionIndicator] = objWithSubQuestion
              }
            } else {
              extractedAnswer[questionIndicator] = subQuestionMatch ? userAnswer.contents.toString() : "";
            }
          } else {
            extractedAnswer[questionIndicator] = ""
          }
        }
        // handle phone number's separated value
        if (layerIndex === 1 && (answerType === 7 || answerType === 8)) {
          // outer answers
          handleSubQuestion(app, obj.subQuestions, countryListDatas, flattenObj, panelStatusObj, layerIndex, subQuestionMatch)
        } else if (layerIndex !== 1 && (answerType === 7 || answerType === 8)) {
          // inner answers
          obj.subQuestions.forEach(question => {
            const {
              questionIndicator,
              userAnswer } = question;
            if (userAnswer) {
              extractedAnswer[questionIndicator] = subQuestionMatch ? userAnswer.contents.toString() : "";
            }
          })
        }
        break;
      }
      case 12:
      {
        const subIndex = layerIndex + 1;
        extractedAnswer = handleRepeatGroup(app, obj, countryListDatas, flattenObj, panelStatusObj, subIndex);
        break;
      }
      case 13: // RegionProportional
      {
        extractedAnswer = handleRegionProportional(obj, countryListDatas);
        break;
      }
      case 14: // Repeat group
      {
        if (!canRepeat) {
          const subIndex = layerIndex + 1;
          const repeatGroupAnswer = handleRepeatGroup(app, obj, countryListDatas, flattenObj, panelStatusObj, subIndex);
          extractedAnswer = repeatGroupAnswer;
          let panelArray = [];
          repeatGroupAnswer.forEach(item => {
            for (let key in item) {
              if (key === "ConEntity" || key === "ConPerNat") {
                panelArray.push(item[key]);
              } else if (key === "ConPer") {
                for (let conPerKey in item[key]) {
                  // if non-expiry date, backend default as 31/12/2049
                  if (conPerKey === "ConPerHaveDateOfExp" && item[key][conPerKey] === "No") {
                    item[key]["ConPerDateOfExp"] = "31-12-2049"
                  }
                }
                panelArray.push(item[key]);
              }
            }
          });
          if (panelArray.length > 0) {
            extractedAnswer = panelArray
          }
        } else {
          const { subQuestions } = obj;
          if (subQuestions) {
            let subQuestionObj = {};
            const subIndex = layerIndex + 1;
            const repeatGroupAnswers = arrayRemoveEmptyElement(
              handleSubQuestion(app, subQuestions, countryListDatas, flattenObj, panelStatusObj, subIndex)
            );
            for (let questionKey in repeatGroupAnswers) {
              const answer = repeatGroupAnswers[questionKey];
              for (let subQuestionKey in answer) {
                subQuestionObj[subQuestionKey] = answer[subQuestionKey]
              }
            }
            extractedAnswer = subQuestionObj;
          }
        }
        break;
      }
      case 17: // SelectGroup
      {
        extractedAnswer = handleSelectGroup(obj, countryListDatas);
        break;
      }
      case 18: // EmailGroup
      {
        extractedAnswer = handleEmailGroup(obj);
        break;
      }
      case 22:// PanelGroup
      {
        const subIndex = layerIndex + 1;
        const panelAnswers = handlePanelList(app, obj, countryListDatas, flattenObj, panelStatusObj, subIndex);
        let panelObj = {};
        panelObj[questionIndicator] = panelAnswers;
        extractedAnswer = panelObj;
        // handle panels question status
        panelStatusObj[questionIndicator]
          ? panelStatusObj[questionIndicator].push(questionStatus)
          : panelStatusObj[questionIndicator] = [questionStatus];
        break;
      }
      default:
        break;
    }

    if (isArrayFn(extractedAnswer) && questionIndicator) {
      const groupAnswer = {};
      let groupIndicator = questionIndicator;
      if ((answerType === 14 || answerType === 17 || answerType === 18 || answerType === 22)
        && questionIndicator.indexOf("Group", [questionIndicator.length - 5]) !== -1) {
        // remove group type indicator's 'Group'
        const endIndex = questionIndicator.indexOf("Group", [questionIndicator.length - 5]);
        groupIndicator = questionIndicator.slice(0, endIndex)
      }
      groupAnswer[groupIndicator] = arrayRemoveEmptyElement(extractedAnswer);
      extractedAnswer = groupAnswer
    }

    if (layerIndex === 1 && extractedAnswer) {
      for (let key in extractedAnswer) {
        flattenObj[key] = subQuestionMatch ? extractedAnswer[key] : isArrayFn(extractedAnswer[key]) ? null : ""
      }
    }
    return extractedAnswer;
  });
};

const handleRegionProportional = (obj, countryListDatas) => {
  const { subQuestions } = obj;
  const [region, ...inputQuestions] = subQuestions;
  let regionProportionalAnswer = {};

  // handle region proportional's region answer
  if (region) {
    const { answers, userAnswer, questionId, questionIndicator, answerType } = region;
    if (userAnswer && answerType === 5) {
      const singleAnswer = arrayFind(answers, userAnswer.chosenAnswerId, "answerId");
      if (singleAnswer && singleAnswer.answerIndicator) {
        regionProportionalAnswer[questionIndicator] = singleAnswer.answerIndicator
      }
    } else if (userAnswer && answerType === 27) {
      const baseAnswerId = questionId.replace('Q', 'A') + ":";

      let singleAnswer = null;
      const length = !!countryListDatas ? countryListDatas.length : 0;
      for (let i = 0; i < length; i++) {
        const country = countryListDatas[i];
        const targetId = baseAnswerId + fix(i + 1);
        if (targetId === userAnswer.chosenAnswerId) {
          singleAnswer = country;
          break;
        }
      }
      if (singleAnswer && singleAnswer.indicator) {
        regionProportionalAnswer[questionIndicator] = singleAnswer.indicator
      }
    }
    
  }

  // handle region proportional's input answers
  inputQuestions.forEach(item => {
    const { userAnswer, questionIndicator } = item;
    if (userAnswer) {
      regionProportionalAnswer[questionIndicator] = userAnswer.contents.toString()
    }
  });

  return regionProportionalAnswer;
};

const handleRepeatGroup = (app, obj, countryListDatas, flattenObj, panelStatusObj, index) => {
  const { subQuestions } = obj;
  return handleSubQuestion(app, subQuestions, countryListDatas, flattenObj, panelStatusObj, index)
};

const handleSelectGroup = (obj, countryListDatas) => {
  const { subQuestions } = obj;
  let answerArray = [];

  if (subQuestions) {
    answerArray = answerArray.concat(subQuestions.map((subQuestion) => {
      const { userAnswer, questionId, questionIndicator, answerType } = subQuestion;
      let groupAnswer = null;
      if (userAnswer) {
        if (answerType === 5) {
          const singleAnswer = arrayFind(subQuestion.answers, userAnswer.chosenAnswerId, "answerId");
          if (singleAnswer && singleAnswer.answerIndicator) {
            groupAnswer = {};
            groupAnswer[questionIndicator] = singleAnswer.answerIndicator
          }
        } else if (answerType === 27) {
          const baseAnswerId = questionId.replace('Q', 'A') + ":";
          let singleAnswer = null;
          const length = !!countryListDatas ? countryListDatas.length : 0;
          for (let i = 0; i < length; i++) {
            const country = countryListDatas[i];
            const targetId = baseAnswerId + fix(i + 1);
            if (targetId === userAnswer.chosenAnswerId) {
              singleAnswer = country;
              break;
            }
          }
          if (singleAnswer && singleAnswer.indicator) {
            groupAnswer = singleAnswer.indicator
          }
        }
      }

      return groupAnswer
    }))
  }

  return answerArray
};

const handleEmailGroup = (obj) => {
  const { subQuestions, questionIndicator } = obj;
  let answerList = null;
  let groupIndicator = null;
  let tempValue = [];

  subQuestions && subQuestions.forEach(subQuestion => {
    if (subQuestion.userAnswer) {
      tempValue.push(subQuestion.userAnswer.contents.toString())
    }
  });
  if (questionIndicator.indexOf("Group", [questionIndicator.length - 5]) !== -1) {
    // remove email group indicator's 'Group'
    const endIndex = questionIndicator.indexOf("Group", [questionIndicator.length - 5]);
    groupIndicator = questionIndicator.slice(0, endIndex)
  }
  if (tempValue.length > 0) {
    answerList = {};
    answerList[groupIndicator ? groupIndicator : questionIndicator] = tempValue
  }

  return answerList
};

const handlePanelList = (app, obj, countryListDatas, flattenObj, panelStatusObj, index) => {
  const { subQuestions } = obj;
  let panelAnswers = null;

  if (subQuestions) {
    let panelObj = {};
    const repeatGroupAnswers = handleSubQuestion(app, subQuestions, countryListDatas, flattenObj, panelStatusObj, index);
    for (let questionKey in repeatGroupAnswers) {
      const answer = repeatGroupAnswers[questionKey];
      for (let subQuestionKey in answer) {
        panelObj[subQuestionKey] = answer[subQuestionKey]
      }
    }
    panelAnswers = panelObj;
  }

  return panelAnswers
};


// 只是String答案用的方法
export const handleFindAnswerbyQuestionIndicator = (json, id) => {
  let myAnswer = "";
  const sections = deepClone(json).sections;
  sections && sections.forEach(section => {
    if(section.sectionId === "S003") {
      const { questions } = section;
      if (!questions) {
        return null;
      }
      questions.map((obj) => {
        obj.subQuestions.forEach(question => {
          const { questionIndicator, userAnswer } = question;
            if(questionIndicator === id) {
              if (userAnswer && userAnswer.contents){
                myAnswer = userAnswer.contents.toString();
              }
            }
        });
      })
    }
  });
  return myAnswer
}
// 账户信息 ->电邮用途，是否勾选：电子发票
export const isHaveEinvoiceFun = (app, countryListDatas) => {
  let isHaveE = false;
  //获取用户填写的所有最终发送后台，更新DB的数据
  const [flattenObj] = handleJsonToAnswer(app, countryListDatas);
  const esta = flattenObj.Esta;
  esta && esta.map((item) => {
    if (item && item.EmailUsage && (item.EmailUsage.indexOf("Einvoice") > -1)) {
      isHaveE = true;
    }
  });
  return isHaveE;
  }
  // 税务信息 ->数电发票，是否勾选：是
  export const isNeedFdeiSerFun = (app, countryListDatas) => {
  let isNeedFdeiSer = false;
  const [flattenObj] = handleJsonToAnswer(app, countryListDatas);
  const qFinancialInformation = flattenObj.QFinancialInformation;
  qFinancialInformation && qFinancialInformation.map((item) => {
    if (item && item.NeedFdeiSer && item.NeedFdeiSer === "YES") {
      isNeedFdeiSer = true;
    }
  });
  return isNeedFdeiSer;
  }


// WEBPACK FOOTER //
// ./src/utils/AOFormAnswerHandler2.js